import api from "../../utils/api/api.utils";
import { BASE_PATH_ENTITY } from "./propertyAmenity.constants";
export var getByPropertyId = function (propertyId) {
    return api.get("/".concat(BASE_PATH_ENTITY, "/property/").concat(propertyId), { isV2: true });
};
export var upsertForProperty = function (propertyId, data) {
    return api.post("/".concat(BASE_PATH_ENTITY, "/property/").concat(propertyId), { isV2: true, data: data });
};
export var removeAmenity = function (id) {
    return api.delete("/".concat(BASE_PATH_ENTITY, "/").concat(id), { isV2: true });
};
